export default __webpack_public_path__ + "static/media/emerald.50416856.svg";